'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RoundButtonWithShadowContainer = exports.MainContainer = exports.HeaderButtonContainer = exports.PageContainer = exports.FullPortViewContainer = undefined;
var _templateObject = _taggedTemplateLiteral(['\n  width: 100vw;\n  height: 100vh;\n  overflow-y: visible;\n  overflow-x: hidden;\n'], ['\n  width: 100vw;\n  height: 100vh;\n  overflow-y: visible;\n  overflow-x: hidden;\n']),
  _templateObject2 = _taggedTemplateLiteral(['\n  width: calc(100% - 63px);\n  float: right;\n  display: flex;\n  flex-direction: column;\n  ', '\n'], ['\n  width: calc(100% - 63px);\n  float: right;\n  display: flex;\n  flex-direction: column;\n  ', '\n']),
  _templateObject3 = _taggedTemplateLiteral(['\n          width:  100%;\n          float: none;\n        '], ['\n          width:  100%;\n          float: none;\n        ']),
  _templateObject4 = _taggedTemplateLiteral(['\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n  margin-bottom: 2rem;\n'], ['\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n  margin-bottom: 2rem;\n']),
  _templateObject5 = _taggedTemplateLiteral(['\n  width: 81%;\n  margin: auto;\n  ', '\n'], ['\n  width: 81%;\n  margin: auto;\n  ', '\n']),
  _templateObject6 = _taggedTemplateLiteral(['\n        padding-left: 0;\n        padding-right: 0;\n        padding-top: 1rem;\n        '], ['\n        padding-left: 0;\n        padding-right: 0;\n        padding-top: 1rem;\n        ']),
  _templateObject7 = _taggedTemplateLiteral(['\n        padding: 0;\n        padding-left: 5rem;\n        '], ['\n        padding: 0;\n        padding-left: 5rem;\n        ']),
  _templateObject8 = _taggedTemplateLiteral(['\n  text-align: center;\n  display: inline-block;\n  font-size: .7rem;\n  color: ', ';\n\n  &:disabled {\n    cursor: default;\n    svg {\n      path {\n        fill: ', ';\n      }\n    }  \n  }\n\n  ', ';\n'], ['\n  text-align: center;\n  display: inline-block;\n  font-size: .7rem;\n  color: ', ';\n\n  &:disabled {\n    cursor: default;\n    svg {\n      path {\n        fill: ', ';\n      }\n    }  \n  }\n\n  ', ';\n']);
var _styledComponents = require('styled-components');
var _styledComponents2 = _interopRequireDefault(_styledComponents);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var FullPortViewContainer = exports.FullPortViewContainer = _styledComponents2.default.div(_templateObject);
var PageContainer = exports.PageContainer = _styledComponents2.default.div(_templateObject2, function (props) {
  var iphones = props.theme.getMedias.iphones;
  return '\n      ' + iphones()(_templateObject3) + '\n    ';
});
var HeaderButtonContainer = exports.HeaderButtonContainer = _styledComponents2.default.div(_templateObject4);
var MainContainer = exports.MainContainer = _styledComponents2.default.main(_templateObject5, function (props) {
  var _props$theme$getMedia = props.theme.getMedias,
    laptops = _props$theme$getMedia.laptops,
    iphones = _props$theme$getMedia.iphones,
    desktops = _props$theme$getMedia.desktops;
  return '\n      ' + laptops()(_templateObject6) + '\n      ' + iphones()(_templateObject7) + '\n      ' + desktops()(_templateObject6) + '\n    ';
});
var RoundButtonWithShadowContainer = exports.RoundButtonWithShadowContainer = _styledComponents2.default.div(_templateObject8, function (props) {
  return props.theme.color_gray;
}, function (props) {
  return props.theme.color_gray;
}, function (props) {
  return props.customstyle;
});